'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export const runtime = 'edge';

export default function CatchAllPage({ params }) {
  const router = useRouter();
  
  useEffect(() => {
    // Always redirect to home page
    router.push('/');
  }, [router]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F9EF]">
      <p className="text-xl">Redirecting...</p>
    </div>
  );
} 